import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const scaleUp = keyframes`
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: ${fadeIn} 0.2s ease-out;
`;

export const ModalContainer = styled.div`
  background: #fff;
  width: 90%;
  max-width: 400px;
  padding: 30px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  animation: ${scaleUp} 0.3s cubic-bezier(0.16, 1, 0.3, 1);
`;

export const IconWrapper = styled.div`
  margin-bottom: 20px;
  
  svg {
    color: #f59e0b;
    font-size: 50px;
  }
`;

export const Title = styled.h2`
  color: #333;
  font-size: 1.4rem;
  margin-bottom: 12px;
  font-weight: 600;
`;

export const Message = styled.p`
  color: #666;
  font-size: 1.125rem;
  line-height: 1.5;
  margin-bottom: 25px;
  text-align: center;
`;

export const PrimaryButton = styled.button`
  width: 50%;
  margin: 0 auto;
  background: #5581f4;
  color: #fff;
  padding: 8px;
  border-radius: 4px;
  border: none;
  font-weight: bold;
  cursor: pointer;
  transition: filter 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    filter: brightness(0.9);
  }
`;